<template>
  <div class="modal" v-if="open">
    <div class="modal__container">
      <div class="modal__wrapper">
        <div class="container">
          <h2 class="heading heading--2" v-text="title"></h2>
          <span class="modal__text" v-html="text"></span>
          <div class="d-md-flex justify-content-end" v-if="showCloseButton">
            <div class="modal__close">
              <div class="button button--primary" @click="close">{{ content.closeOverlayLabel }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  props: {
    title: String,
    text: String,
    showCloseButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    ...mapGetters([
      'content'
    ])
  },
  mounted() {
    setTimeout(() => {
      document.body.classList.add('no-scroll')
      this.open = true;
    }, 50)
  },
  methods: {
    close: function () {
      document.body.classList.remove('no-scroll')
      this.open = false;
    }
  }
}
</script>

<style lang="scss">
.modal {
  &__container {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    overflow-y: scroll;
    width: 100vw;
    height: 100vh;
    background-color: rgba(247, 247, 247, 0.75);
  }

  &__wrapper {
    margin: 150px auto;
    width: 50%;
    height: auto;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08), 0 0 50px 0 rgba(0, 0, 0, 0.05);
    padding: 25px 0;

    @media (max-width: 1203px) {
      width: 75%;
    }

    @media (min-width: 768px) {
      position: absolute;
      top: 50%;
      left: 50%;

      transform: translate(-50%, -50%);

      margin: 0;
      padding: 45px;
    }

    .heading {
      text-align: left;
      margin-bottom: 19px;
    }
  }

  &__text {
    font-weight: 400;
    font-family: LegacyPro,Times New Roman,Times,serif;
    font-size: 16px;
    line-height: 1.57;
    color: rgba(96,75,51,.7);
    margin: 0;
  }

  &__close {
    @media (max-width: 768px) {
      margin-top: 26px;
    }
    @media (min-width: 768px) {
      margin-left: 20px;
      width: calc(25% - 15px);
    }
    min-width: 160px;
    justify-content: flex-end;

    margin-top:40px;

    button, .button {
      width: 100%;
    }
  }
}
</style>


